module.exports = __webpack_public_path__ + "img/dillan.322ee5e5.png";